export default "<h1> eReader  - Passenger Engagements </h1>\r\n<p>Compares the engagement of Electronic Reader (eReader) versus other media types.</p>\r\n\r\n";